export default {
  games: [],
  courses: [],
  authors: [],
  apiCallsInProgress: 0,
};
